<mat-toolbar color="primary">
  <a mat-button routerLink="/" class="title-link">
    <span>Site Manager</span>
  </a>
  <app-org-switcher />
  <span class="flex-spacer"></span>
  <app-patient-omnisearch class="toolbar-omnisearch" #omnisearch />
  <span class="flex-spacer"></span>
  @if (isCompact()) {
    <button mat-icon-button aria-label="Open patient search" (click)="openOmnisearch()">
      <mat-icon>search</mat-icon>
    </button>
  }
  @if (orgStore.isSuperuser()) {
    <a mat-button routerLink="/management">
      <mat-icon>settings</mat-icon>
      <span>Admin</span>
    </a>
  }
  <button mat-icon-button (click)="themeService.toggle()">
    <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
  </button>
  <app-user-menu />
</mat-toolbar>
